/**
 * Provinzial Versicherung – E-V-B domain knowledge.
 *
 * This data is embedded directly in the Realtime system prompt so the
 * voice assistant can answer E-V-B-related questions without tool calls.
 */

export const EVB_DOMAIN_KNOWLEDGE_MD = `# E-V-B – elektronische Versicherungsbestätigung

## Was ist eine E-V-B?
Die E-V-B-Nummer (elektronische Versicherungsbestätigung) ist ein 7-stelliger alphanumerischer Code, der als Nachweis der Kfz-Haftpflichtversicherung dient. Sie wird von der Kfz-Zulassungsstelle bei Anmeldung, Ummeldung oder Fahrzeugwechsel verlangt.

## Format
- 7 Zeichen: Großbuchstaben (ohne I und O) und Ziffern (0–9).
- Die ersten zwei Zeichen kennzeichnen den Versicherer (bei Provinzial: PV).
- Beispiel: PV3A8K2

## Wann wird eine E-V-B benötigt?
- Neuanmeldung eines Fahrzeugs
- Ummeldung (Halterwechsel)
- Wiederzulassung nach Stilllegung
- Fahrzeugwechsel auf bestehender Police

## Ausstellung
- Die E-V-B wird sofort elektronisch erstellt und per SMS oder E-Mail übermittelt.
- Sie ist in der Regel 6 Monate gültig (danach verfällt sie, wenn nicht genutzt).

## Welche Daten werden benötigt?
Für die Erstellung einer E-V-B benötigen wir idealerweise:
- Fahrzeugdaten: Marke, Modell, Baujahr, Fahrgestellnummer (FIN)
- Gewünschter Versicherungsumfang: Haftpflicht, Teilkasko, Vollkasko
- Gewünschtes Versicherungsbeginn-Datum

**Wichtig:** Die Fahrgestellnummer und detaillierte Fahrzeugdaten sind hilfreich, aber NICHT zwingend erforderlich für die Erstellung der E-V-B. Im Zweifel kann die E-V-B auch ohne FIN ausgestellt und die Daten später nachgereicht werden.

## Deckungsoptionen
| Option | Beschreibung |
|--------|-------------|
| Haftpflicht | Gesetzlich vorgeschrieben. Deckt Schäden, die Sie anderen zufügen. |
| Teilkasko | Zusätzlich: Diebstahl, Glasbruch, Wildunfall, Sturm, Hagel, Brand. |
| Vollkasko | Teilkasko + selbstverschuldete Unfälle und Vandalismus. |

## Häufige Probleme
- **E-V-B nicht akzeptiert:** Kann passieren, wenn die E-V-B nicht final aktiviert wurde oder abgelaufen ist. Lösung: alte E-V-B stornieren, neue ausstellen.
- **E-V-B abgelaufen:** Nach 6 Monaten ohne Zulassung verfällt die E-V-B. Eine neue muss erstellt werden.
- **Fahrzeugwechsel:** Bei einem Wechsel wird die bestehende Police auf das neue Fahrzeug umgemeldet. Es kann eine Beitragsdifferenz entstehen.
`;
